module.exports = __webpack_public_path__ + "img/fien-troch-thumb.99b769ea.jpg";